import React, { useState } from "react";
import HeroSection from "../components/HeroSection";

function ContactUs() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null); // success | error message

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus(null);

    try {
      const form = new FormData();
      form.append("name", formData.name);
      form.append("phone", formData.phone);
      form.append("email", formData.email);
      form.append("message", formData.message);

      const response = await fetch(
        "https://dsdspl.com/mp_funds/public/api/public/contact",
        {
          method: "POST",
          body: form,
        }
      );

      const data = await response.json();

      if (response.ok) {
        setStatus({
          type: "success",
          message: data.message || "Message sent successfully!",
        });
        setFormData({ name: "", phone: "", email: "", message: "" }); // reset form
      } else {
        setStatus({
          type: "error",
          message: data.message || "Failed to send message.",
        });
      }
    } catch (error) {
      console.error("[Contact error]:", error);
      setStatus({
        type: "error",
        message: "Something went wrong. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {/* Hero banner */}
      <HeroSection />

      <div className="mx-auto max-w-6xl px-4">
        <h1 className="text-3xl sm:text-4xl font-bold text-center mt-2 mb-8 text-green-600">
          Contact Us
        </h1>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
          {/* Map left */}
          <div className="rounded-2xl overflow-hidden border">
            <img
              src="https://images.unsplash.com/photo-1528909514045-2fa4ac7a08ba?q=80&w=1600&auto=format&fit=crop"
              alt="Map placeholder"
              className="w-full h-[380px] object-cover"
            />
          </div>

          {/* Form right */}
          <form className="space-y-4" onSubmit={handleSubmit}>
            {status && (
              <div
                className={`p-3 rounded-lg text-sm ${
                  status.type === "success"
                    ? "bg-green-100 text-green-700"
                    : "bg-red-100 text-red-700"
                }`}
              >
                {status.message}
              </div>
            )}

            <input
              className="w-full rounded-xl border px-4 py-3"
              placeholder="Name"
              value={formData.name}
              onChange={(e) => handleChange("name", e.target.value)}
              required
            />
            <input
              className="w-full rounded-xl border px-4 py-3"
              placeholder="Mobile number"
              value={formData.phone}
              onChange={(e) => handleChange("phone", e.target.value)}
              required
            />
            <input
              className="w-full rounded-xl border px-4 py-3"
              placeholder="Email address"
              type="email"
              value={formData.email}
              onChange={(e) => handleChange("email", e.target.value)}
              required
            />
            <textarea
              className="w-full rounded-xl border px-4 py-3 min-h-[120px]"
              placeholder="Message"
              value={formData.message}
              onChange={(e) => handleChange("message", e.target.value)}
              required
            />
            <button
              type="submit"
              className="rounded-xl bg-green-500 text-white px-6 py-3 font-medium hover:bg-green-600 disabled:opacity-50"
              disabled={loading}
            >
              {loading ? "Sending..." : "Send message"}
            </button>
          </form>
        </div>

        {/* Info row */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 mt-10 text-sm">
          <div className="flex items-start gap-3">
            <span className="text-red-500 text-xl">☎</span>
            <div>
              <div className="font-semibold">Call</div>
              <div className="text-gray-600">+91 9800098525</div>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <span className="text-red-500 text-xl">✉</span>
            <div>
              <div className="font-semibold">Email</div>
              <div className="text-gray-600">abcd132@gmail.com</div>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <span className="text-red-500 text-xl">📍</span>
            <div>
              <div className="font-semibold">Location</div>
              <div className="text-gray-600">Balia, UP</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactUs;
